import { gql } from '@common/hooks';

export const WorksMembershipUpdate = gql`
  mutation WorksMembershipUpdate(
    $id: ID!
    $input: UpdateWorksMembershipInput!
  ) {
    updateWorksMembership(id: $id, input: $input) {
      worksMembership {
        id
      }
    }
  }
`;

export type WorksMembershipUpdateResponse = {
  updateWorksMembership: {
    worksMembership: {
      id: string;
    };
  };
};
